const initState = () => {
  return {
    candidates: [],
    candidate: 'all'
  }
}

const contactCandidateList = (state=initState(), action) => {
  switch (action.type) {
    case "SET_CONTACT_CANDIDATES_LIST":
      return Object.assign({}, state, {candidates: action.payload})

    case "SET_CONTACT_CANDIDATES_LIST_SELECTION":
      return Object.assign({}, state, {candidate: action.payload})

    default:
      return state;
  }
}

export default contactCandidateList;
